export default () => {
  $(document).on(`click`, `a[href^="#"]`, function (event) {
    event.preventDefault();

    $(`html, body`).animate({
        scrollTop: $($.attr(this, `href`)).offset().top + 5
    }, 500);
  });
};
